export type ChatFocus = {
  messageId: number;
  timestamp: string;
};

const STORAGE_KEY = 'harbor.chat.focus';

let pending: ChatFocus | null = null;

export function setPendingChatFocus(focus: ChatFocus): void {
  pending = focus;
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(focus));
}

export function peekPendingChatFocus(): ChatFocus | null {
  if (pending) return pending;
  if (typeof sessionStorage === 'undefined') return null;
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ChatFocus;
  } catch {
    return null;
  }
}

export function clearPendingChatFocus(): void {
  pending = null;
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(STORAGE_KEY);
}

export function consumePendingChatFocus(): ChatFocus | null {
  const next = peekPendingChatFocus();
  if (next) clearPendingChatFocus();
  return next;
}

export function timestampJustAfter(iso: string): string {
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return iso;
  return new Date(parsed.getTime() + 1).toISOString();
}
